import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import { FormState } from 'src/types';
import {
  CloseIcon,
  TopBannerDescription,
  TopBannerStyled,
} from './TopBanner.styles';

interface Props {
  state: FormState.ERROR | FormState.WARNING | FormState.SUCCESS;
  description: string;
  onCloseBanner?: () => void;
  'data-testid'?: string;
}

export const TopBanner = ({
  state,
  description,
  onCloseBanner,
  ...props
}: Props) => {
  const theme = useTheme();
  return (
    <TopBannerStyled {...props} state={state}>
      <StyledIcon
        className="uil uil-exclamation-triangle"
        size="24px"
        color={theme.atlas.semantic.color.type.default}
      />
      <TopBannerDescription>{description}</TopBannerDescription>
      {onCloseBanner && (
        <CloseIcon
          size="24px"
          className="uil uil-multiply"
          onClick={onCloseBanner}
          color={theme.atlas.semantic.color.type.default}
        />
      )}
    </TopBannerStyled>
  );
};
